import '@ingka/base/dist/style.min.css';
import '@ingka/svg-icon/dist/style.min.css';
import '@ingka/typography/dist/style.min.css';
import '@ingka/animations/dist/style.min.css';
import '@ingka-group-digital/nav-content-container/dist/style.css';
import '@ingka/accordion/dist/style.min.css';
import '@ingka/accordion-item/dist/style.min.css';
import '@ingka/aspect-ratio-image/dist/style.min.css';
import '@ingka/button/dist/style.min.css';
import '@ingka/hyperlink/dist/style.min.css';
import '@ingka/loading/dist/style.min.css';
import '@ingka/modal/dist/style.min.css';
import '@ingka/quantity-dropdown/dist/style.min.css';
import '@ingka/search/dist/style.min.css';
import '@ingka/search/dist/style.rtl.min.css';
import '@ingka/status/dist/style.min.css';
import '@ingka/toast/dist/style.min.css';
import '@ingka/toast/dist/style.rtl.min.css';
import '@ingka/forms/dist/style.min.css';
import '@ingka/forms/dist/style.rtl.min.css';
import '@ingka/focus/dist/style.min.css';
import '@ingka/inline-message/dist/style.css';
import '@ingka/breadcrumb/dist/style.css';
import '@ingka/toggle/dist/style.css';
import './styles/style.css';
